import { render, staticRenderFns } from "./EventPlanner.vue?vue&type=template&id=9284a124&scoped=true&"
import script from "./EventPlanner.vue?vue&type=script&lang=js&"
export * from "./EventPlanner.vue?vue&type=script&lang=js&"
import style0 from "./EventPlanner.vue?vue&type=style&index=0&id=9284a124&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9284a124",
  null
  
)

export default component.exports